
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
} from "@/components/ui/card";

interface ReviewsManagementHeaderProps {
  isPurging: boolean;
  onPurge: () => void;
}

const ReviewsManagementHeader = ({ isPurging, onPurge }: ReviewsManagementHeaderProps) => {
  return (
    <Card className="mb-6 border-none shadow-md">
      <CardContent>
        <p className="text-gray-600">
          This page allows you to manage reviews that have been reported by users.
          You can view reports, manage review visibility, and resolve issues.
        </p>
        <Button
          variant="destructive"
          className="mt-4"
          onClick={onPurge}
          disabled={isPurging}
        >
          {isPurging ? "Purging..." : "Purge Orphaned Review Reports"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ReviewsManagementHeader;
